export default "__VITE_ASSET__7d87391e__"